/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const REMIX_SUGGESTIONS = [
  "Mẹo: Dùng ảnh có độ tương phản cao để in đẹp hơn.",
  "Mẹo: Thử với các loại ốp màu trong suốt.",
  "Mẹo: Tải ảnh vẽ tay (artwork) để tạo phong cách độc đáo.",
  "Mẹo: Kiểm tra vị trí camera để tránh bị cắt mất chi tiết ảnh.",
];

interface FooterProps {
  isOnDressingScreen?: boolean;
}

const Footer: React.FC<FooterProps> = ({ isOnDressingScreen = false }) => {
  const [suggestionIndex, setSuggestionIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSuggestionIndex((prevIndex) => (prevIndex + 1) % REMIX_SUGGESTIONS.length);
    }, 5000); 

    return () => clearInterval(interval);
  }, []);

  return (
    <footer className={`fixed left-0 right-0 bg-white/95 backdrop-blur-sm border-t border-slate-200 px-4 py-2.5 z-10 ${isOnDressingScreen ? 'hidden md:block md:bottom-0' : 'bottom-0'}`}>
      <div className="mx-auto flex items-center justify-center text-xs text-slate-500 max-w-7xl">
        <div className="flex items-center gap-2">
            <span className="font-medium text-slate-400 text-[10px] md:text-xs">INFO</span>
            <div className="h-4 overflow-hidden relative w-48 md:w-96">
                <AnimatePresence mode="wait">
                <motion.p
                    key={suggestionIndex}
                    initial={{ opacity: 0, y: 8 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -8 }}
                    transition={{ duration: 0.3 }}
                    className="absolute inset-0 text-center truncate text-[10px] md:text-xs"
                >
                    {REMIX_SUGGESTIONS[suggestionIndex]}
                </motion.p>
                </AnimatePresence>
            </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;